import './ChristmasLoader.scss';

export function ChristmasLoader() {
  return (
    <div className="christmas-loader-wrapper">
      <div className="christmas-loader">
      {/* Snowman container */}
      <div className="snowman-container">
        {/* Snowman SVG */}
        <svg
          width="120"
          height="120"
          viewBox="200 220 200 200"
          className="snowman-svg animate-snowman-bounce"
        >
          <defs>
            {/* Gradients */}
            <radialGradient id="snowWhite" cx="30%" cy="30%">
              <stop offset="0%" stopColor="#FFFFFF" />
              <stop offset="70%" stopColor="#F0F8FF" />
              <stop offset="100%" stopColor="#E0E8F0" />
            </radialGradient>

            <radialGradient id="snowShadow" cx="50%" cy="50%">
              <stop offset="0%" stopColor="#E0E8F0" />
              <stop offset="100%" stopColor="#C0D0E0" />
            </radialGradient>

            <linearGradient id="carrotOrange" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FF8C42" />
              <stop offset="50%" stopColor="#FF7F32" />
              <stop offset="100%" stopColor="#E85D04" />
            </linearGradient>

            <linearGradient id="scarfRed" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#EF5350" />
              <stop offset="50%" stopColor="#E53935" />
              <stop offset="100%" stopColor="#C62828" />
            </linearGradient>

            <linearGradient id="topHatBlack" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#1A1A1A" />
              <stop offset="40%" stopColor="#2D2D2D" />
              <stop offset="100%" stopColor="#0A0A0A" />
            </linearGradient>

            <linearGradient id="hatBand" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#DC2626" />
              <stop offset="50%" stopColor="#B91C1C" />
              <stop offset="100%" stopColor="#991B1B" />
            </linearGradient>

            <radialGradient id="buttonShine" cx="30%" cy="30%">
              <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.6" />
              <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
            </radialGradient>

            <filter id="shadow">
              <feDropShadow dx="0" dy="4" stdDeviation="3" floodOpacity="0.2" />
            </filter>
          </defs>

          {/* Ground shadow */}
          <ellipse
            cx="300"
            cy="410"
            rx="45"
            ry="6"
            fill="#000000"
            opacity="0.1"
          />

          {/* Snowman */}
          <g>
            {/* Bottom snowball */}
            <circle
              cx="300"
              cy="380"
              r="30"
              fill="url(#snowWhite)"
              stroke="#C0D0E0"
              strokeWidth="1.5"
              filter="url(#shadow)"
            />
            <circle
              cx="300"
              cy="380"
              r="30"
              fill="url(#snowShadow)"
              opacity="0.25"
            />

            {/* Buttons */}
            <circle cx="300" cy="365" r="2.5" fill="#212121">
              <ellipse cx="299" cy="364" rx="0.8" ry="0.8" fill="url(#buttonShine)" />
            </circle>
            <circle cx="300" cy="380" r="2.5" fill="#212121">
              <ellipse cx="299" cy="379" rx="0.8" ry="0.8" fill="url(#buttonShine)" />
            </circle>
            <circle cx="300" cy="395" r="2.5" fill="#212121">
              <ellipse cx="299" cy="394" rx="0.8" ry="0.8" fill="url(#buttonShine)" />
            </circle>

            {/* Red scarf */}
            <g>
              <ellipse
                cx="300"
                cy="350"
                rx="32"
                ry="6"
                fill="url(#scarfRed)"
                stroke="#B71C1C"
                strokeWidth="1"
              />
              <ellipse
                cx="300"
                cy="349"
                rx="32"
                ry="4"
                fill="#EF5350"
                opacity="0.5"
              />

              {/* Scarf ends */}
              <path
                d="M268 350 L263 368 L267 370 L271 350 Z"
                fill="url(#scarfRed)"
                stroke="#B71C1C"
                strokeWidth="1"
              />
              <rect x="264" y="356" width="3" height="1.5" fill="#B71C1C" />
              <rect x="264" y="363" width="3" height="1.5" fill="#B71C1C" />

              <path
                d="M332 350 L337 368 L333 370 L329 350 Z"
                fill="url(#scarfRed)"
                stroke="#B71C1C"
                strokeWidth="1"
              />
              <rect x="333" y="356" width="3" height="1.5" fill="#B71C1C" />
              <rect x="333" y="363" width="3" height="1.5" fill="#B71C1C" />
            </g>

            {/* Head snowball */}
            <circle
              cx="300"
              cy="328"
              r="22"
              fill="url(#snowWhite)"
              stroke="#C0D0E0"
              strokeWidth="1.5"
              filter="url(#shadow)"
            />
            <circle
              cx="300"
              cy="328"
              r="22"
              fill="url(#snowShadow)"
              opacity="0.25"
            />

            {/* Top Hat */}
            <g>
              {/* Brim */}
              <ellipse
                cx="300"
                cy="306"
                rx="26"
                ry="4"
                fill="url(#topHatBlack)"
                stroke="#000000"
                strokeWidth="1"
              />
              <ellipse
                cx="300"
                cy="305"
                rx="24"
                ry="3"
                fill="#3D3D3D"
                opacity="0.6"
              />

              {/* Hat body */}
              <rect
                x="282"
                y="280"
                width="36"
                height="26"
                fill="url(#topHatBlack)"
                stroke="#000000"
                strokeWidth="1"
                rx="1.5"
              />
              <rect
                x="282"
                y="280"
                width="12"
                height="26"
                fill="#4A4A4A"
                opacity="0.5"
                rx="1.5"
              />
              <rect
                x="306"
                y="280"
                width="12"
                height="26"
                fill="#000000"
                opacity="0.5"
                rx="1.5"
              />

              {/* Hat top */}
              <ellipse
                cx="300"
                cy="280"
                rx="18"
                ry="3"
                fill="url(#topHatBlack)"
                stroke="#000000"
                strokeWidth="1"
              />
              <ellipse
                cx="300"
                cy="279.5"
                rx="15"
                ry="2"
                fill="#3D3D3D"
                opacity="0.6"
              />

              {/* Red band */}
              <rect
                x="281"
                y="295"
                width="38"
                height="6"
                fill="url(#hatBand)"
                stroke="#7C1C1C"
                strokeWidth="0.5"
                rx="0.5"
              />
              <rect
                x="281"
                y="295"
                width="12"
                height="6"
                fill="#EF5350"
                opacity="0.4"
                rx="0.5"
              />
              
              {/* Buckle */}
              <rect
                x="297"
                y="296"
                width="4"
                height="4"
                fill="#FFD700"
                stroke="#DAA520"
                strokeWidth="0.5"
                rx="0.3"
              />

              {/* Shine */}
              <ellipse
                cx="288"
                cy="287"
                rx="4"
                ry="8"
                fill="#FFFFFF"
                opacity="0.25"
              />
            </g>

            {/* Carrot nose */}
            <path
              d="M300 328 L318 326 L300 333 Z"
              fill="url(#carrotOrange)"
              stroke="#E85D04"
              strokeWidth="1"
            />
            <path
              d="M300 328 L314 327 L300 331 Z"
              fill="#FF8C42"
              opacity="0.5"
            />

            {/* Eyes */}
            <circle cx="292" cy="323" r="2.5" fill="#212121" />
            <circle cx="291" cy="322" r="0.8" fill="#FFFFFF" opacity="0.7" />

            <circle cx="308" cy="323" r="2.5" fill="#212121" />
            <circle cx="307" cy="322" r="0.8" fill="#FFFFFF" opacity="0.7" />

            {/* Smile */}
            <circle cx="292" cy="335" r="1.5" fill="#212121" />
            <circle cx="296" cy="337" r="1.5" fill="#212121" />
            <circle cx="300" cy="338" r="1.5" fill="#212121" />
            <circle cx="304" cy="337" r="1.5" fill="#212121" />
            <circle cx="308" cy="335" r="1.5" fill="#212121" />

            {/* Left arm */}
            <g className="animate-arm-wave">
              <rect
                x="250"
                y="365"
                width="30"
                height="3"
                fill="#6D4C41"
                stroke="#4E342E"
                strokeWidth="1"
                rx="1.5"
                transform="rotate(-30 270 367)"
              />
              <rect
                x="250"
                y="365"
                width="10"
                height="3"
                fill="#8D6E63"
                opacity="0.4"
                rx="1.5"
                transform="rotate(-30 270 367)"
              />
            </g>

            {/* Right arm */}
            <g className="animate-arm-wave" style={{ animationDelay: '0.15s' }}>
              <rect
                x="320"
                y="365"
                width="30"
                height="3"
                fill="#6D4C41"
                stroke="#4E342E"
                strokeWidth="1"
                rx="1.5"
                transform="rotate(30 330 367)"
              />
              <rect
                x="340"
                y="365"
                width="10"
                height="3"
                fill="#8D6E63"
                opacity="0.4"
                rx="1.5"
                transform="rotate(30 330 367)"
              />
            </g>
          </g>
        </svg>
      </div>

      {/* Candy Cane Progress Bar */}
      <div className="progress-container">
        {/* Progress bar container */}
        <div className="progress-bar-wrapper">
          {/* Progress fill with animated candy cane stripes - faster spiral */}
          <div 
            className="progress-fill animate-candy-fill"
          >
            <div 
              className="candy-stripes animate-candy-stripes-fast"
                style={{ 
                backgroundImage: `repeating-linear-gradient(
                  45deg,
                  #DC2626 0px,
                  #DC2626 8px,
                  #FFFFFF 8px,
                  #FFFFFF 16px
                )`,
                backgroundSize: '22.6px 22.6px',
              }}
            />
          </div>

          {/* Animated shine effect for forward motion */}
          <div className="shine-sweep animate-shine-sweep">
            <div className="shine-gradient" style={{ width: '30%' }} />
          </div>

          {/* Glossy shine overlay */}
          <div className="glossy-overlay" />
          
          {/* Enhanced sparkle effects */}
          <div className="sparkle sparkle-1 animate-sparkle-1" />
          <div className="sparkle sparkle-2 animate-sparkle-2" />
          <div className="sparkle sparkle-3 animate-sparkle-3" />
        </div>

        {/* Loading text in red */}
        <p className="loading-text animate-loading-pulse">
          Loading...
        </p>
      </div>

        <style>{`
        @keyframes snowmanBounce {
          0%, 100% {
            transform: translateY(0) rotate(0deg);
          }
          25% {
            transform: translateY(-4px) rotate(-2deg);
          }
          50% {
            transform: translateY(0) rotate(0deg);
          }
          75% {
            transform: translateY(-4px) rotate(2deg);
          }
        }

        @keyframes armWave {
          0%, 100% {
            transform: rotate(0deg);
          }
          50% {
            transform: rotate(-15deg);
          }
        }

        @keyframes candyStripesFast {
          0% {
            background-position: 0 0;
          }
          100% {
            background-position: 22.6px 22.6px;
          }
        }

        @keyframes candyFill {
          0% {
            width: 0%;
          }
          25% {
            width: 25%;
          }
          50% {
            width: 50%;
          }
          75% {
            width: 75%;
          }
          100% {
            width: 100%;
          }
        }

        @keyframes shineSweep {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(400%);
          }
        }

        @keyframes sparkle1 {
          0%, 100% {
            opacity: 0;
            transform: scale(0.8);
          }
          50% {
            opacity: 1;
            transform: scale(1.3);
          }
        }

        @keyframes sparkle2 {
          0%, 100% {
            opacity: 0;
            transform: scale(0.6);
          }
          40% {
            opacity: 0.9;
            transform: scale(1.2);
          }
        }

        @keyframes sparkle3 {
          0%, 100% {
            opacity: 0;
            transform: scale(0.7);
          }
          60% {
            opacity: 0.95;
            transform: scale(1.25);
          }
        }

        @keyframes loadingPulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }


        .animate-snowman-bounce {
          animation: snowmanBounce 1.8s ease-in-out infinite;
          }

          .animate-arm-wave {
          animation: armWave 0.9s ease-in-out infinite;
          transform-origin: 270px 367px;
        }

        .animate-candy-stripes-fast {
          animation: candyStripesFast 0.4s linear infinite;
        }

        .animate-candy-fill {
          animation: candyFill 2.5s ease-in-out infinite;
        }

        .animate-shine-sweep {
          animation: shineSweep 1.5s ease-in-out infinite;
        }

        .animate-sparkle-1 {
          animation: sparkle1 1.5s ease-in-out infinite;
        }

        .animate-sparkle-2 {
          animation: sparkle2 1.8s ease-in-out infinite 0.3s;
        }

        .animate-sparkle-3 {
          animation: sparkle3 1.6s ease-in-out infinite 0.6s;
        }

        .animate-loading-pulse {
          animation: loadingPulse 1.5s ease-in-out infinite;
        }

        `}</style>
      </div>
    </div>
  );
}
